import React, { useRef, useEffect, useState } from 'react';
import './navbar-routes.css';

export default function NavbarRoutes({ openCustomizationModal }) {
  const [currentTime, setCurrentTime] = useState('');

useEffect(() => {
    const updateClock = (startTime, endTime) => {
      const now = new Date();
      const hours = now.getHours();
      const minutes = now.getMinutes();
      const formattedTime = `${hours % 12 || 12}:${minutes < 10 ? '0' + minutes : minutes} ${hours >= 12 ? 'pm' : 'am'}`;
      setCurrentTime(formattedTime);

      // Parse "HH:MMam/pm" into total minutes (24h) for comparison
      const parseTime = (timeStr) => {
        const isPM = timeStr.toLowerCase().includes('pm');
        const [h, m] = timeStr.replace(/am|pm/i, "").split(":").map(Number);
        let hour = h;
        if (isPM && h !== 12) hour = h + 12;
        if (!isPM && h === 12) hour = 0;
        return hour * 60 + m;
      };

      const currentMinutes = hours * 60 + minutes;
      const startMinutes = parseTime(startTime);
      const endMinutes = parseTime(endTime);

      // Handle same-day and overnight ranges
      const isInInterval = startMinutes <= endMinutes
        ? currentMinutes >= startMinutes && currentMinutes < endMinutes  // e.g. "8:00am" - "5:00pm"
        : currentMinutes >= startMinutes || currentMinutes < endMinutes; // e.g. "10:00pm" - "8:00am"

      if (isInInterval) {
        // Darken screen brightness
        document.getElementById('screen-brightness').style.opacity = '0.3';
      }
      else{
        // set to normal screen brightness
        document.getElementById('screen-brightness').style.opacity = '0';
      }
    };

    updateClock("10:00pm", "7:00am"); // 👈 pass your custom times here

    const intervalId = setInterval(() => updateClock("10:00pm", "8:00am"), 5000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <>
      <div className='screen-brightness' id='screen-brightness'></div>
      <div className='navbar-routes-container'>
        <div className='navbar-routes-title-time-container'>
          {currentTime}
        </div>
        <div className='navbar-routes-title-container'>
          Choocago!
        </div>
        <div className='navbar-routes-open-customization-container' onClick={openCustomizationModal}>
          Customize
        </div>
      </div>
    </>
  );
}
